import { render, staticRenderFns } from "./EcashKitsDemoted.vue?vue&type=template&id=3cb958a4&"
import script from "./EcashKitsDemoted.vue?vue&type=script&lang=js&"
export * from "./EcashKitsDemoted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports